import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import { DATETIME_FORMAT, DATE_FORMAT, formatReceived } from 'utils/formatValues';

export const baseURI = '/recaudacion/multas/';

/**
 * GET Multas
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getMultas = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    const output = { ...response.data, results: formatReceived(response.data.results) };
    return output;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Multa
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getMulta = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Multas
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postMulta = async (values) => {
  try {
    const formattedValues = {
      ...values,
      hora_multa: values.hora_multa ? values.hora_multa.format(DATETIME_FORMAT) : undefined,
      fecha_de_multa: values.fecha_de_multa
        ? values.fecha_de_multa.format(DATE_FORMAT) : undefined,
    };
    const response = await API.post(baseURI, formattedValues);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Multas
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchMulta = async (id, values) => {
  try {
    const formattedValues = {
      ...values,
      hora_multa: values.hora_multa ? values.hora_multa.format(DATETIME_FORMAT) : undefined,
      fecha_de_multa: values.fecha_de_multa
        ? values.fecha_de_multa.format(DATE_FORMAT) : undefined,
    };
    const response = await API.patch(`${baseURI}${id}`, formattedValues);
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE ZonaExclusiva
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteMulta = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Multas Caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */

export const getMultasCaja = async (params = null) => {
  try {
    const response = await API.get('/recaudacion/multas-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
